/* global axios */
import ApiClient from './ApiClient';

class GgFollowupAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  context(conversationId, params = {}, { signal } = {}) {
    return axios.get(`${this.url}/${conversationId}/gg_followups`, {
      params,
      signal,
    });
  }

  preview(
    conversationId,
    firstMessageId,
    lastMessageId,
    target,
    { signal } = {}
  ) {
    return axios.post(
      `${this.url}/${conversationId}/gg_followups/preview`,
      {
        first_message_id: firstMessageId,
        last_message_id: lastMessageId,
        ...target,
      },
      { signal }
    );
  }

  range(conversationId, firstMessageId, lastMessageId, { signal } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/gg_followups/range`,
      {
        first_message_id: firstMessageId,
        last_message_id: lastMessageId,
      },
      { signal }
    );
  }

  setOpportunity(conversationId, opportunityId) {
    return axios.post(`${this.url}/${conversationId}/custom_attributes`, {
      custom_attributes: { oportunidade: opportunityId },
      merge: true,
    });
  }

  analyze(conversationId, requestId, { signal } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/gg_followups/analyze`,
      { request_id: requestId },
      { signal }
    );
  }

  operation(conversationId, requestId, { signal } = {}) {
    return axios.get(`${this.url}/${conversationId}/gg_followups/operation`, {
      params: { request_id: requestId },
      signal,
    });
  }

  confirm(conversationId, requestId, text, { signal } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/gg_followups/confirm`,
      {
        request_id: requestId,
        reviewed: true,
        texto_confirmado: text,
      },
      { signal }
    );
  }

  restart(conversationId, requestId, mode, { signal, analysisText } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/gg_followups/restart`,
      {
        request_id: requestId,
        mode,
        ...(analysisText !== undefined ? { analysis_text: analysisText } : {}),
      },
      { signal }
    );
  }

  note(conversationId, requestId, { signal } = {}) {
    return axios.post(
      `${this.url}/${conversationId}/gg_followups/note`,
      { request_id: requestId },
      { signal }
    );
  }
}

export default new GgFollowupAPI();
